import { createFileRoute } from '@tanstack/react-router';
import { BetaGatePage } from '@/features/auth/BetaGatePage';

export const Route = createFileRoute('/signup/beta')({ component: BetaGatePage });
